import React from 'react'

const AppConfigContext = React.createContext(null)

export default AppConfigContext
